// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jDpHw","comment":"styles_comment__18iDz"};